import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Customers';
moduleConfig.singleItemTitle = 'Customer';
moduleConfig.url = 'customers';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Archive Selected",
        value: "Archive"
    },
    {
        displayName: "Restore Selected",
        value: "Restore"
    }
];

moduleConfig.breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  // details: {
  //   label: "Details",
  //   url: `/${moduleConfig.url}/${id}`,
  // },
  update: {
    label: "Update",
  },
  create: {
    label: "Create",
  },
}

export default moduleConfig;